import { useRef, useState } from "react";
import {
  HeroWrapper,
  VideoBackground,
  Overlay,
  Content,
  // Eyebrow,
  Heading,
  Subheading,
  Actions,
  PrimaryBtn,
  SecondaryBtn,
} from "./styles/HeroSection.styles";

import heroBounce from "../../assets/videos/hero_bounce.mp4";
import preloadImg from "../../assets/images/preload.webp";

// Framer Motion variants
const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (delay = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] },
  }),
};

function HeroSection() {
  const videoRef = useRef(null);
  const [videoLoaded, setVideoLoaded] = useState(false);

  return (
    <HeroWrapper>
      <VideoBackground>
        {/* Preload slika dok se video ucitava */}
        {!videoLoaded && (
          <img
            src={preloadImg}
            alt=""
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 1,
            }}
          />
        )}
        <video
          ref={videoRef}
          autoPlay
          muted
          playsInline
          preload="auto"
          loop
          src={heroBounce}
          poster={preloadImg}
          onLoadedData={() => setVideoLoaded(true)}
          style={{
            opacity: videoLoaded ? 1 : 0,
            transition: "opacity 0.5s ease",
          }}
        />
      </VideoBackground>

      <Overlay />

      <Content>
        {/* <Eyebrow
          variants={fadeUp}
          initial="hidden"
          animate="visible"
          custom={0.2}
        >
          Authorized Princess Yachts Representative
        </Eyebrow> */}

        <Heading
          variants={fadeUp}
          initial="hidden"
          animate="visible"
          custom={0.4}
        >
          Guided by <em>light</em>. Defined by the sea.
        </Heading>

        <Subheading
          variants={fadeUp}
          initial="hidden"
          animate="visible"
          custom={0.6}
        >
          New builds, distinguished pre-owned vessels, and bespoke commissions.
          Guided from discovery to delivery.
        </Subheading>

        <Actions
          variants={fadeUp}
          initial="hidden"
          animate="visible"
          custom={0.8}
        >
          <PrimaryBtn to="/yachts">Explore Yachts</PrimaryBtn>
          <SecondaryBtn to="/brands">View Brands</SecondaryBtn>
        </Actions>
      </Content>
    </HeroWrapper>
  );
}

export default HeroSection;
